export default __webpack_public_path__ + "static/media/congratulations_winner.3c735ade.mp3";